const focusItems = [
  {
    title: '2025暑期档观影指南',
    desc: '炎炎夏日，宅家看电影才是正经事。我们为你整理了暑期最值得关注的十部新片，以及最值得重温的十部经典，让你的夏天被好电影填满。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20night%20with%20projector%20in%20backyard%2C%20warm%20golden%20sunset%20light%2C%20cozy%20outdoor%20cinema%20setting%2C%20film%20reels%20and%20popcorn%2C%20relaxed%20summer%20vibe%2C%20cinematic%20photography&width=1000&height=600&seq=carousel-summer-97&orientation=landscape',
    label: '专题策划',
  },
  {
    title: '豆瓣TOP250全收录',
    desc: '我们整理了豆瓣评分最高的250部电影，横跨数十年的经典佳片尽在其中。从《肖申克的救赎》到《千与千寻》，每一部都值得反复品味。',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20library%20with%20classic%20film%20collection%2C%20warm%20reading%20lamp%20glow%2C%20vintage%20movie%20poster%20wall%2C%20wooden%20bookshelves%2C%20intellectual%20cinema%20atmosphere%2C%20golden%20hour%20lighting&width=1000&height=600&seq=carousel-douban-97&orientation=landscape',
    label: '高分合集',
  },
  {
    title: '经典港片修复计划',
    desc: '那些年我们追过的港片，经过4K修复后焕然一新。周星驰的无厘头、成龙的拼命、王家卫的文艺，经典影像永不褪色。',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20neon%20street%20at%20night%2C%20vintage%20cinema%20aesthetic%2C%20old%20school%20movie%20theater%2C%20colorful%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20nostalgic%20mood%2C%20warm%20retro%20lighting&width=1000&height=600&seq=carousel-hk-97&orientation=landscape',
    label: '修复经典',
  },
  {
    title: '科幻电影百年回顾',
    desc: '从《大都会》到《阿凡达》，从《2001太空漫游》到《星际穿越》，一百年科幻电影发展史中那些改变游戏规则的里程碑作品。',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20spaceship%20cockpit%20with%20stars%20visible%20through%20window%2C%20dramatic%20cosmic%20purple%20and%20blue%20lighting%2C%20sci-fi%20movie%20tribute%20style%2C%20cinematic%20wide%20shot%2C%20epic%20space%20vista&width=1000&height=600&seq=carousel-scifi-97&orientation=landscape',
    label: '百年科幻',
  },
  {
    title: '动画电影合家欢',
    desc: '从吉卜力到皮克斯，从迪士尼到国产动画，适合全家一起观看的动画电影精选。让好故事陪伴孩子的成长，也唤醒你的童心。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20fantasy%20world%2C%20whimsical%20storybook%20style%2C%20warm%20golden%20magical%20light%2C%20playful%20atmosphere%2C%20soft%20pastel%20colors%2C%20enchanting%20fairytale%20landscape%2C%20cinematic%20composition&width=1000&height=600&seq=carousel-anime-97&orientation=landscape',
    label: '合家欢',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          焦点推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          编辑团队精选的五大焦点专题，深度观影从这里开始
        </p>
        <div className="flex flex-col gap-6">
          {focusItems.map((item, i) => (
            <article
              key={i}
              className={`group flex flex-col ${i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-5 bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-0.5`}
            >
              <div className="lg:w-[45%] h-52 lg:h-64 flex-shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 flex flex-col justify-center p-5 lg:p-8">
                <span className="inline-flex px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold w-fit mb-3">
                  {item.label}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}